import { Skeleton } from 'antd';
import { Valuation as ValuationComponent, PostOffer, Notes } from 'components/common';
import { CaseSidebarItemId } from 'components/CaseSidebar/types';
import { BankDetailsPage } from 'pages/BankDetailsPage';
import { EvidenceTabContent } from 'pages/EvidencePage/EvidenceTabContent';
import { OverviewPage } from 'pages/OverviewPage';
import { CaseOverview } from './Overview';
import { CaseFinancingPage } from './Financing';
import { CaseApplicantsPage } from './Applicants';
import { CaseExpensesPage } from './Expenses';
import { CasePropertyPage } from './Property';
import type { ComponentType } from 'react';
import type { OoFormRouteContext } from './types';

export function ooFormNavigationMap(context: OoFormRouteContext): Partial<Record<CaseSidebarItemId, ComponentType>> {
  return {
    [CaseSidebarItemId.OVERVIEW]: () => <CaseOverview case={context.case} isLoading={context.isCaseLoading} />,
    [CaseSidebarItemId.FINANCING]: () => (
      <CaseFinancingPage case={context.case} isCaseLoading={context.isCaseLoading} />
    ),
    [CaseSidebarItemId.APPLICANTS]: () => (
      <CaseApplicantsPage case={context.case} isCaseLoading={context.isCaseLoading} />
    ),
    [CaseSidebarItemId.EXPENSES]: () => (
      <CaseExpensesPage caseId={context.caseId} isCaseLoading={context.isCaseLoading} />
    ),
    [CaseSidebarItemId.PROPERTY]: () => (
      <CasePropertyPage caseId={context.caseId} sidebarContext={context.sidebarContext} />
    ),
    [CaseSidebarItemId.CUSTOMER_FILES]: () => (
      <OverviewPage
        sections={context.sections}
        applicationFilesInternal={context.applicationFilesInternal}
        showBankDetailsTask
        isBankDetailsComplete={context.isBankDetailsComplete}
        onGoToEvidenceV2={context.onGoToEvidence}
        onGoToBankDetails={context.onGoToBankDetails}
      />
    ),
    [CaseSidebarItemId.EVIDENCE]: () => (
      <EvidenceTabContent
        caseId={context.caseId}
        sections={context.sections}
        isCaseTasksLoading={context.isCaseTasksLoading}
        isEmbedded
      />
    ),
    [CaseSidebarItemId.BANK_DETAILS]: () => (
      <BankDetailsPage
        applicationId={context.caseId}
        bankAccount={context.bankAccount}
        isLoading={context.isCaseLoading}
        openInEditMode={context.openBankDetailsInEditMode}
        onOpenInEditModeConsumed={context.onOpenBankDetailsInEditModeConsumed}
      />
    ),
    [CaseSidebarItemId.VALUATION]: () => <ValuationComponent valuation={context.valuation} />,
    [CaseSidebarItemId.POST_OFFER]: () =>
      context.isConveyancingLoading ? (
        <Skeleton active paragraph={{ rows: 8 }} />
      ) : (
        <PostOffer conveyancing={context.conveyancing} />
      ),
    [CaseSidebarItemId.COMMUNICATION]: () => (
      <div className='mt-6'>
        <Notes notes={context.formattedNotes} onCreateNote={context.onCreateNote} isLoading={context.isCreatingNote} />
      </div>
    ),
  };
}
